import React, { useContext, useEffect } from "react";
import { Heading, Text, TextField } from "@foris/avocado-suite";
import { BookingContext } from "../../context/BookingContext";
import { Types } from "../../context/search.reducer";
import { Types as SavedRequestTypes } from "../../context/savedRequest.reducer";
import { Icon } from "@foris/avocado-icons";
import css from "./requirements.module.scss";
import { useTranslation } from "react-i18next";

const Requirements = () => {
  const { state, dispatch } = useContext(BookingContext);
  const { t } = useTranslation();

  let error = null;
  if (state?.search?.requirements?.people?.error) error = "Ingresa la capacidad requerida";

  useEffect(() => {
    const booking = state?.search?.currentBooking;
    const capacity = state?.savedRequest?.bookingCapacity;

    if (!booking) return;

    const payload = {
      ...state?.search?.requirements,
      people: {
        ...state?.search?.requirements?.people,
        count: capacity ?? booking?.capacity ?? booking?.classroom?.capacity,
        error: false,
      },
    };

    dispatch({
      type: SavedRequestTypes.setSavedBookingCapacity,
      payload: null,
    });
    dispatch({ type: Types.SetRequirements, payload });
  }, []);

  return (
    <section className={css.requirements}>
      <Heading type="h4" className={css.requirements_title}>
        {t("booking.booking-form.classroom-requirements.title")}
      </Heading>

      <TextField
        className={css.requirements_input}
        type="number"
        label={t("booking.booking-form.classroom-requirements.capacity")}
        placeholder={t("booking.booking-form.classroom-requirements.required-capacity")}
        status={!!error ? "error" : undefined}
        statusText={error}
        value={state?.search?.requirements?.people?.count || ""}
        onWheel={e => e.currentTarget.blur()}
        onChange={value => {
          const cloneRequirements = { ...state?.search?.requirements };
          cloneRequirements.people.count = parseInt(value.target.value);
          cloneRequirements.people.error = false;
          dispatch({ type: Types.SetRequirements, payload: cloneRequirements });
        }}
      />

      <div className={css.requirements_info}>
        <Icon className={css.infoIcon} name="circle-info" size="sm" filled color="info-60" />

        <Text className={css.infoText} type="sm">
          <b className={css.infoText_important}>
            {t("booking.booking-form.classroom-requirements.info.title")}
          </b>{" "}
          {t("booking.booking-form.classroom-requirements.info.description")}
        </Text>
      </div>
    </section>
  );
};

export default Requirements;
